
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ConsoleActionResult } from './types';
import ActionsListPanel from './action-panels/ActionsListPanel.vue';
import StagingCreatePanel from './action-panels/StagingCreatePanel.vue';
import StagingMergePanel from './action-panels/StagingMergePanel.vue';
import AliasCreatePanel from './action-panels/AliasCreatePanel.vue';
import SubdomainCreatePanel from './action-panels/SubdomainCreatePanel.vue';
import WpInstallPanel from './action-panels/WpInstallPanel.vue';
import WpUninstallPanel from './action-panels/WpUninstallPanel.vue';
import ToggleWebsitePanel from './action-panels/ToggleWebsitePanel.vue';
import RenameWebsitePanel from './action-panels/RenameWebsitePanel.vue';
import DeleteWebsitePanel from './action-panels/DeleteWebsitePanel.vue';
import RecreateWebsitePanel from './action-panels/RecreateWebsitePanel.vue';
import RetryActionPanel from './action-panels/RetryActionPanel.vue';
import DnsManagePanel from './action-panels/DnsManagePanel.vue';
import SslManagePanel from './action-panels/SslManagePanel.vue';
import DbManagePanel from './action-panels/DbManagePanel.vue';
import MailManagePanel from './action-panels/MailManagePanel.vue';
import FtpManagePanel from './action-panels/FtpManagePanel.vue';
import VhostManagePanel from './action-panels/VhostManagePanel.vue';
import RedisManagePanel from './action-panels/RedisManagePanel.vue';

@Component({
  components: {
    ActionsListPanel,
    StagingCreatePanel,
    StagingMergePanel,
    AliasCreatePanel,
    SubdomainCreatePanel,
    WpInstallPanel,
    WpUninstallPanel,
    ToggleWebsitePanel,
    RenameWebsitePanel,
    DeleteWebsitePanel,
    RecreateWebsitePanel,
    RetryActionPanel,
    DnsManagePanel,
    SslManagePanel,
    DbManagePanel,
    MailManagePanel,
    FtpManagePanel,
    VhostManagePanel,
    RedisManagePanel,
  },
})
export default class ConsoleActionPanel extends Vue {
  @Prop({ type: Object, required: true })
  public result!: ConsoleActionResult;

  @Prop({ type: Boolean, default: false })
  public busy!: boolean;

  public get panelBusy(): boolean {
    return this.busy || this.result.phase === 'pending';
  }

  public get panelError(): string {
    return this.result.errorMessage || '';
  }

  public metaNumber(key: string): number {
    const meta = this.result.meta || {};
    const value = meta[key];
    return typeof value === 'number' ? value : 0;
  }

  public metaString(key: string): string {
    const meta = this.result.meta || {};
    const value = meta[key];
    return typeof value === 'string' ? value : '';
  }
}
